import { CollectionState } from '../types/types';

/**
 * Creates an array with each resource object
 * @param {CollectionState<T>} [object] - an object with a resources organized in a byId object and an allIds array
 * @return {T[]} - an array of each resource object
 */
export default function collectionSpread<T>({ allIds, byId }: CollectionState<T>) {
  return allIds.map((id) => byId[id]);
}